import React, { Component } from "react";
import { TableContainer, Paper } from "@material-ui/core";
import { orderBy } from "../../utils/helper";
import PaginationControlled from "../common/pagination/pagination";

export default React.memo(
  class TableWithPaginations extends Component {
    constructor(props) {
      super(props);
      this.state = {
        pageNo: props.pageNo || 0,
        rowsPerPagination: 100
      };
    }

    // get values from props and set to state.
  static getDerivedStateFromProps(newProps, state) {
    if (
      newProps.pageNo !== state.pageNo
    ) {
      return {
        pageNo: newProps.pageNo
      }
    }
  }

    /**
     * update page count when change value from dropdown
     * @param {*} pageNo - page name
     * @param {*} rowsPerPagination -> number of record per page
     */
    updateRowCount = (pageNo, rowsPerPagination) => {
      const { updatePageCount } = this.props;
      this.setState({ pageNo, rowsPerPagination });
      updatePageCount(pageNo);
    };

    render() {
      const { tableData = [], renderTable, order, oBy, sortData, paginationData } = this.props;
      const { rowsPerPagination } = this.state;
      const data =
        sortData === undefined
          ? orderBy(tableData, oBy, order)
          : sortData(tableData);
      const pageNo =
        data?.length > rowsPerPagination * this.state.pageNo
          ? this.state.pageNo
          : 0;

      return (
        <>
          <div className={"paginationContainer"}>
            <PaginationControlled
              parentKey={"topPagination"}
              tableLength={paginationData?.length}
              updateRowCount={this.updateRowCount}
              pageNo={pageNo}
              rowsPerPagination={rowsPerPagination}
            />
          </div>
          <TableContainer component={Paper} style={{ maxWidth: "100vw" }}>
            {renderTable(
              rowsPerPagination > 0
                ? data?.slice(
                    pageNo * rowsPerPagination,
                    pageNo * rowsPerPagination + rowsPerPagination
                  )
                : data
            )}
          </TableContainer>
          <div className={"paginationContainer"}>
            <PaginationControlled
              parentKey={"bottomPagination"}
              tableLength={paginationData?.length}
              updateRowCount={this.updateRowCount}
              pageNo={pageNo}
              rowsPerPagination={rowsPerPagination}
            />
          </div>
        </>
      );
    }
  }
);
